const INTERVAL_CAROUSEL_WAIT  = 5000;
const INTERVAL_CAROUSEL_MOVE  = 500;
const VECTOR_RIGHT = 'right';
const VECTOR_LEFT = 'left';
const MARGIN_CHILD = parseInt($('.dn-carousel__child').css('margin-right'))*2;

const DISTANCE_CHILD = {
    get width(){
        this.width_child = $('.dn-carousel__childWrap').width();
        if(this.width_child <= 0){
            this.width_child = $(window).width();
        }
        return this.width_child;
    }
}
const startCarousel = {
    init(){
        carouselCtrl.init();
        this.setTimer();
    },
    setTimer(){
        this.timer = setTimeout(function() {
            carouselCtrl.checkChildren(VECTOR_LEFT);  
        },INTERVAL_CAROUSEL_WAIT);
        this.isTimer = true;
    },
    clearTimer(){
        clearTimeout(this.timer);
    }
}

const carouselCtrl = {
    init(){
        this.wrapDOM =  $('.dn-carousel__childWrap');
        this.page_max = Math.ceil($('.dn-carousel__child').length/3);
        console.log(this.page_max);
        this.page_cur = 1;
        this.setArrowAble();
    },
    setArrowAble(){
        // 未公開記事もカルーセルに並べるか否か、現状は未公開記事も準備中として並べてる。
        if(this.page_cur == 1){
            $('#vectorL').addClass('active');
            $('#vectorR').removeClass('active');
        }
        else if(this.page_cur == this.page_max){
            $('#vectorL').removeClass('active');
            $('#vectorR').addClass('active');
        }
        else{
            $('#vectorL').addClass('active');
            $('#vectorR').addClass('active');
        }
    },
    checkChildren(vector){
        if(0 <= this.page_cur && this.page_cur <= this.page_max){
            this.animateChildren(vector);
        }
    },
    animateChildren(vector){
        const TARGET_CAROUSEL = $('.dn-carousel__child:first');
        let offsetLeft = parseInt(TARGET_CAROUSEL.css('margin-left'));

        if(this.page_cur == 1)offsetLeft = 4;

        if(startCarousel.isTimer && this.page_cur == this.page_max){
            offsetLeft = 4;
            this.page_cur = 1;
        }
        else if(vector==VECTOR_LEFT){
            offsetLeft -= DISTANCE_CHILD.width;
            if(this.page_cur < this.page_max)this.page_cur++;
        }
        else{
            offsetLeft += DISTANCE_CHILD.width;
            if(this.page_cur > 0)this.page_cur--;
        }

        TARGET_CAROUSEL.animate({
            marginLeft: offsetLeft
        },
        INTERVAL_CAROUSEL_MOVE,
        function(){
            startCarousel.setTimer();
        }); 
    // ループ用
// }, INTERVAL_CAROUSEL_MOVE,function(){carouselCtrl.moveChild(vector)}); 
    startCarousel.clearTimer();
        this.setArrowAble();
    },
    moveChild(vector){
        if(vector==VECTOR_LEFT){
            $('.dn-carousel__child:first').appendTo(this.wrapDOM);
        }
        else{
            $('.dn-carousel__child:last').prependTo(this.wrapDOM);
        }
    }
}


$(function(){
    startCarousel.init();
    $(document).on('click','#vectorL.active',function(){
        if(!$('.dn-carousel__child:first').is(':animated')){
            startCarousel.isTimer = false;
            carouselCtrl.checkChildren(VECTOR_LEFT);
        }
    });
    $(document).on('click','#vectorR.active',function(){
        startCarousel.isTimer = false;
        if(!$('.dn-carousel__child:first').is(':animated')){
        carouselCtrl.checkChildren(VECTOR_RIGHT);
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/top/carousel-in-banner.js